@use '@/styles/tokens' as *;

// Figma button variants (node 114-73). Heights/radius/padding/font sizes come
// from antd Button component tokens in src/config/theme.ts; colors live here.
// Double-class selectors out-rank antd's own variant styles on specificity ties.

.button {
  gap: 10px;
  box-shadow: none;

  &:disabled {
    background: var(--surface-muted);
    border-color: var(--surface-muted);
    color: var(--overlay-20);
  }
}

.button.highlight {
  background: $color-accent1-500;
  border-color: $color-accent1-500;
  color: var(--text-primary);

  &:hover:not(:disabled) {
    background: $color-accent1-400;
    border-color: $color-accent1-200;
    color: var(--text-primary);
  }
}

.button.primary {
  background: $color-brand-950;
  border-color: $color-brand-950;
  color: $color-accent1-500;

  &:hover:not(:disabled) {
    background: $color-brand-900;
    border-color: $color-brand-800;
    color: $color-accent1-500;
  }
}

.button.neutral {
  background: $color-neutral-950;
  border-color: $color-neutral-950;
  color: var(--text-inverse);

  &:hover:not(:disabled) {
    background: $color-neutral-900;
    border-color: $color-neutral-600;
    color: var(--text-inverse);
  }
}

.button.secondary {
  background: var(--surface-secondary);
  border-color: var(--surface-secondary);
  color: var(--text-primary);

  &:hover:not(:disabled) {
    background: var(--surface-secondary);
    border-color: $color-light-brown-400;
    color: var(--text-primary);
  }
}

.button.subtle {
  background: $color-white-50;
  border-color: $color-white-400;
  color: var(--text-primary);

  &:hover:not(:disabled) {
    background: $color-white-100;
    border-color: $color-white-600;
    color: var(--text-primary);
  }
}

.button.outline {
  background: transparent;
  border-color: $color-white-600;
  color: var(--text-primary);

  &:hover:not(:disabled) {
    background: $color-white-50;
    border-color: $color-white-500;
    color: var(--text-primary);
  }

  &:disabled {
    background: transparent;
    border-color: $color-white-500;
  }
}

.icon {
  display: inline-flex;

  > svg {
    width: 14px;
    height: 14px;
  }
}

.button:global(.ant-btn-lg) .icon > svg {
  width: 16px;
  height: 16px;
}

.button:global(.ant-btn-sm) .icon > svg {
  width: 12px;
  height: 12px;
}
